import { render, staticRenderFns } from "./construction.vue?vue&type=template&id=256e4e86&scoped=true&"
import script from "./construction.vue?vue&type=script&lang=js&"
export * from "./construction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256e4e86",
  null
  
)

export default component.exports